// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__eHLpd","title":"Info_title__38b4G","selects":"Info_selects__6_2pb","requiredAsterisk":"Info_requiredAsterisk__vFTLt"};